import { Navigate } from 'react-router-dom';
import { getAuthToken } from './auth';
import { decodedToken } from './auth';

const ProtectedRoute = ({ children, requiredPermission = null, anyOfPermissions = [] }) => {
  const token = getAuthToken();
  
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // **Permission-based access control**
  if (requiredPermission || anyOfPermissions.length > 0) {
    const decode = decodedToken();
    const userPermissions = decode?.permissions || {};

    // Check if user has specific required permission
    if (requiredPermission && !userPermissions[requiredPermission]) {
      return <Navigate to="/dashboard" replace />;
    }

    // Check if user has any of the specified permissions
    if (anyOfPermissions.length > 0) {
      const hasAnyPermission = anyOfPermissions.some(permission => 
        userPermissions[permission] === true
      );
      if (!hasAnyPermission) {
        return <Navigate to="/dashboard" replace />;
      }
    }
  }
  return children;
};

export default ProtectedRoute;